export default "__VITE_ASSET__BKWpRRuH__"